import { Stage } from '../Stage';
import type { BriefingScreenProps } from './types';

/**
 * Mobile briefing/lobby shell — board fills the screen between a custom
 * header and a footer pinned to the bottom. The board scrolls behind the
 * footer; a soft cork-frame gradient fades content under the CTAs so the
 * scroll seam reads as designed paper, not a hard cut.
 */
export const MobileBriefingScreen = ({
  board,
  mobileHeader,
  mobileFooter,
}: Pick<BriefingScreenProps, 'board' | 'mobileHeader' | 'mobileFooter'>) => (
  <Stage tone="board">
    <main className="relative mx-auto flex h-full w-full max-w-md flex-col">
      <div className="shrink-0 px-4 pt-4">{mobileHeader}</div>
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-4 pt-3 pb-[160px]">
        {board}
      </div>
      <div
        className="pointer-events-none absolute right-0 bottom-0 left-0 px-4 pt-10 pb-4"
        style={{
          backgroundImage:
            'linear-gradient(to top, var(--color-cork-frame) 55%, color-mix(in srgb, var(--color-cork-frame) 75%, transparent) 80%, transparent 100%)',
        }}
      >
        <div className="pointer-events-auto mx-auto max-w-md">{mobileFooter}</div>
      </div>
    </main>
  </Stage>
);
